import { useEffect } from "react";
import { Platform } from "react-native";
export const FontAwesomeKitLoader = ({ id, children, }) => {
    useEffect(() => {
        if (Platform.OS === "web" && id) {
            const script = document.createElement("script");
            script.src = `https://kit.fontawesome.com/${id}.js`;
            script.crossOrigin = "anonymous";
            document.head.appendChild(script);
        }
    }, [id]);
    return children;
};
//# sourceMappingURL=FontAwesomeKitLoader.js.map